if (!customElements.get("enova-shop-look")) {
  customElements.define(
    "enova-shop-look",
    class EnovaShopLook extends HTMLElement {
      connectedCallback() {
        if (this.hasInitialized) return;
        this.hasInitialized = true;

        this.trigger = this.querySelector(".enova-shop-look__trigger");
        this.dialog = this.querySelector("dialog");
        this.closeBtn = this.querySelector("[data-enova-look-close]");

        if (!this.trigger || !this.dialog) return;

        this.trigger.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.open();
        });
        this.closeBtn && this.closeBtn.addEventListener("click", () => this.close());
        this.dialog.addEventListener("click", (event) => {
          const panel = this.dialog.querySelector(".enova-shop-look__panel");
          if (panel && !panel.contains(event.target)) this.close();
        });

        this.dialog.querySelectorAll("[data-enova-look-variant]").forEach((select) => {
          select.addEventListener("change", () => this.onVariantChange(select));
        });

        this.dialog.querySelectorAll("[data-enova-look-form]").forEach((form) => {
          form.addEventListener("submit", (event) => this.onSubmit(event));
        });

        document.body.appendChild(this.dialog);
        this.placeTrigger();
        this.mql = window.matchMedia("(max-width: 767px)");
        this.onMqlChange = () => this.placeTrigger();
        if (this.mql.addEventListener) {
          this.mql.addEventListener("change", this.onMqlChange);
        } else {
          this.mql.addListener(this.onMqlChange);
        }
      }

      placeTrigger() {
        const gallery = this.closest("media-gallery");
        if (!gallery || !this.trigger) return;

        const inner = gallery.querySelector(".m-media-gallery__inner");
        const first = gallery.querySelector(".m-media-gallery__list .m-product-media--item");
        const mobile = window.matchMedia("(max-width: 767px)").matches;
        const host = mobile ? inner : first;

        if (host && this.trigger.parentElement !== host) {
          host.appendChild(this.trigger);
        }
      }

      open() {
        this.dialog.showModal();
      }

      close() {
        if (this.dialog.open) this.dialog.close();
      }

      onVariantChange(select) {
        const card = select.closest("[data-enova-look-card]");
        if (!card) return;

        const option = select.options[select.selectedIndex];
        const idInput = card.querySelector("[data-enova-look-id]");
        const price = card.querySelector("[data-enova-look-price]");
        const image = card.querySelector(".enova-shop-look__image");
        const button = card.querySelector("[data-enova-look-atc]");

        if (idInput) idInput.value = option.value;
        if (price && option.dataset.price) price.textContent = option.dataset.price;
        if (image && option.dataset.image) image.src = option.dataset.image;

        if (button) {
          const available = option.dataset.available === "true";
          button.disabled = !available;
          button.textContent = available
            ? button.dataset.atcText
            : window.MinimogStrings.soldOut;
        }
      }

      onSubmit(event) {
        event.preventDefault();
        const form = event.currentTarget;
        const button = form.querySelector("[data-enova-look-atc]");
        const idInput = form.querySelector("[data-enova-look-id]");
        const variantId = idInput && idInput.value;
        if (!variantId || (button && button.disabled)) return;

        const atcText = button ? button.dataset.atcText : "";
        if (button) {
          button.disabled = true;
          button.classList.add("is-loading");
        }

        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:grouped-sections", {
            bubbles: true,
            detail: { sections: sectionsToBundle },
          })
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(form);
        formData.append("sections", sectionsToBundle);
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        fetch(`${window.MinimogSettings.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              window.MinimogTheme.Notification.show({
                target: document.body,
                method: "appendChild",
                type: "error",
                message: response.description || response.message,
                last: 3000,
                sticky: true,
              });
              return;
            }

            const cart = document.querySelector("m-cart-drawer");
            if (cart && window.MinimogSettings.enable_cart_drawer) {
              window.MinimogTheme.Notification.show({
                target: cart.querySelector("m-cart-items"),
                method: "prepend",
                type: "success",
                message: window.MinimogStrings.itemAdded,
                delay: 400,
              });
              this.close();
              cart.open();
            } else {
              window.MinimogTheme.Notification.show({
                target: document.body,
                method: "appendChild",
                type: "success",
                message: window.MinimogStrings.itemAdded,
                last: 3000,
                sticky: true,
              });
            }

            window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, {
              cart: response,
              productVariantId: variantId,
            });
          })
          .catch(() => {})
          .finally(() => {
            if (button) {
              button.disabled = false;
              button.classList.remove("is-loading");
              button.textContent = atcText;
            }
          });
      }
    }
  );
}
